const topics = [
  {
    title: "Air",
        slug: "air",
standardNumber: "PS.3.1",

    description: "Understand the structure and properties of matter before and after they undergo a change.",
    video: "",
    music: "",
    lyrics: [
      
    ],
       gameType: "multipleChoice",

    titleImage: "", // Motion image URL
  },
  {
    title: "Matter Rock",
    slug: "matterrock",
    standardNumber: "PS.3.1",
    description: "Understand the structure and properties of matter before and after they undergo a change.",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fmatterrock2025video.mp4?alt=media&token=9dcb63a2-cfea-49ca-8cc7-0d30700ecab3",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmatterrock2025song.mp3?alt=media&token=78f1e7a9-8c65-4b5a-8489-430d502eb06c",
    lyrics: ["(Chorus)",
"Matter has mass and takes up space.",
"Matter has mass and takes up space.",
"Three states of matter,",
"Solid, liquid, and gas.",
"Three states of matter,",
"Solid, liquid, and gas.",

"(Verse)",
"Solids, they keep their shape.",
"Solids, they keep their shape.",
"Particles are packed tightly in solids, vibrating.",
"Particles are packed tightly in solids, vibrating.",

"Liquids take the shape of its container.",
"Liquids take the shape of its container.",
"Particles are spread out a little, sliding past each other.",
"Particles are spread out a little, sliding past each other.",

"In gases, the shape will change with its container.",
"In gases, the volume will change with its container.",
"Particles are spread out and move very quickly.",
"Particles are spread out and move very quickly.",

"(Chorus)",
"Matter has mass and takes up space.",
"Matter has mass and takes up space.",
"Three states of matter,",
"Solid, liquid, and gas.",
"Three states of matter,",
"Solid, liquid, and gas.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
{
    title: "3 States of Matter",
    slug: "3statesofmatter",
    standardNumber: "PS.3.1",
    description: "PS.3.1 Understand the structure and properties of matter before and after they undergo a change.",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2F3statesofmatter2025video.mp4?alt=media&token=a521644b-b4eb-4a56-89e2-2beb95c71ad7",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2F3statesofmatter2025song.mp3?alt=media&token=4ca634b8-d275-41d6-9e49-36d59970db1b",
    lyrics: ["(Chorus)",
"Matter is everything around you.",
"Matter is made of atoms and molecules.",
"3 states: solids, liquids, gases.",
"3 states: solids, liquids, gases.",

"(Verse)",
"Solids, yes, are hard.",
"Liquids are more like water.",
"Gases are like the atmosphere,",
"That surrounds the earth, our air.",
"Solids, yes, are hard.",
"Liquids are more like water.",
"Gases are like the atmosphere,",
"That surrounds the earth, our air.",
"Those are the 3 states of matter,",
"Those are the 3 states of matter.",
"Solids, liquids, gases.",
"Solids, liquids, gases.",

"(Chorus)",
"Matter is everything around you.",
"Matter is made of atoms and molecules.",
"3 states: solids, liquids, gases.",
"3 states: solids, liquids, gases.",

"© Smart Board Learning, LLC. All rights reserved.",
    ],
    gameType: "multipleChoice",
    titleImage: "", // Motion image URL
  },
  {
    title: "Heating & Cooling",
        slug: "heatingandcooling",
    standardNumber: "PS.3.1",
    description: "Understand the structure and properties of matter before and after they undergo a change.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fheatingandcooling2025song.mp3?alt=media&token=f9370550-3077-42ee-a0a0-a8a01a268baa",
    lyrics: [
      "(chorus)",
"Heat it up, cool it down,",
"Watch the changes all around!",
"Liquids to gas, or solid to ice,",
"Heating and cooling, science is nice!",

"(verse)",
"Add some heat, water turns to steam,",
"It floats in the air like a misty dream.",
"Cool it down, and watch it fall,",
"Rain turns to puddles, that’s not all!",
"Heat melts butter, chocolate too,",
"Cooling makes them hard, it’s what they do!",
"Ice turns to water, then back again,",
"Heating and cooling are science friends!",

"(chorus)",
"Heat it up, cool it down,",
"Watch the changes all around!",
"Liquids to gas, or solid to ice,",
"Heating and cooling, science is nice!",

"(verse)",
"Evaporation makes water disappear,",
"Heating it up sends it out of here!",
"Cooling it down makes it come back,",
"Forming clouds or frost, on nature’s track.",
"So heat it up, and cool it too,",
"Changes in matter are fun to do.",
"Evaporation, melting, freezing, it’s true,",
"Heating and cooling teach me and you!",

"(chorus)",
"Heat it up, cool it down,",
"Watch the changes all around!",
"Liquids to gas, or solid to ice,",
"Heating and cooling, science is nice!",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "", // Motion image URL
  },
  {
    title: "Friction",
        slug: "friction",
    standardNumber: "PS.3.3",
    description: "Understand how energy can be transferred from one object to another.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Ffriction2025song.mp3?alt=media&token=38d656a0-f811-4c14-98f3-c7f744ccaa75",
    lyrics: ["(chorus)",
"The resistance to motion is friction.",
"The resistance to motion is friction.",

"(verse)",
"Made by two objects moving against each other, each other.",
"Made by two objects moving against each other, each other.",
"Friction creates heat.",
"Friction creates heat.",
"When you rub your hands together",
"you cause a resistance to motion,",
"then you feel heat from friction, from friction.",

"(chorus)",
"The resistance to motion is friction.",
"The resistance to motion is friction.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "", // Motion image URL
  },
  {
    title: "Heat Moves All Around",
        slug: "heatmovesallaround",
    standardNumber: "PS.3.3",
    description: "PS.3.3 Understand how energy can be transferred from one object to another.",
    video: "",
    music: "",
    lyrics: [
      
    ],
    gameType: "multipleChoice",
    titleImage: "", // Motion image URL
  },
  {
    title: "Force",
        slug: "force",
    standardNumber: "PS.3.2",

    description: "Understand motion and factors that affect motion.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fforce.mp4?alt=media&token=d90d58e8-21a5-403e-9cb9-4d065fb9c655",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fforce2025song.mp3?alt=media&token=aeed54c4-234a-4568-800a-a2b8ab0c9b11",
    lyrics: ["(Chorus)",
"If you give a push or give a pull,",
"That is force to an object.",
"If you give a push or give a pull,",
"That is force to an object.",

"(Verse)",
"Force is a push or a pull that will,",
"Make an object stop.",
"Force is a push or a pull that will,",
"Change an object's speed.",
"Force is a push or a pull that will,",
"Change an object's direction.",
"Force is a push or a pull that will,",
"Change an object's direction.",

"(Chorus)",
"If you give a push or give a pull,",
"That is force to an object.",
"If you give a push or give a pull,",
"That is force to an object.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Motion",
slug: "motion",
    standardNumber: "PS.3.2",
    description: "Understand motion and factors that affect motion.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fmotion2025video.mp4?alt=media&token=90933e74-b520-41d9-8d19-f01f4a9a2204",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: ["(Chorus)",
"If an object changes its position,",
"Then a motion has occurred.",
"If it continuously changes its position,",
"Then it's in motion, then it's in motion.",

"(Verse)",
"Use a car as an example, and the car is parked at the curb.",
"Now, you move the car up 10 feet, then a motion has occurred.",
"Now, if you take the same parked car and put it on the highway,",
"Then start coasting.",
"Its position is constantly changing.",
"Then, it's in motion, then it's in motion.",

"(Chorus)",
"If an object changes its position,",
"Then a motion has occurred.",
"If it continuously changes its position,",
"Then it's in motion, then it's in motion.",
"If an object changes its position,",
"Then a motion has occurred.",
"If it continuously changes its position,",
"Then it's in motion, then it's in motion.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Speed & Motion",
    slug: "speedandmotion",
    standardNumber: "PS.3.2",
    description: "PS.3.2 Understand motion and factors that affect motion.",
    video: "",
    music: "",
    lyrics: [

],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Gravity",
    slug: "gravity",
    standardNumber: "PS.3.2",
    description: "Understand motion and factors that affect motion.",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fgravityvideo.mp4?alt=media&token=63493362-6c8b-4590-ac8f-49b9b794b17a",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fgravity2025song.mp3?alt=media&token=48857943-5ba4-441d-b04b-0802504ceae4",
    lyrics: ["(chorus)",
"Earth is one of eight planets that go around the sun.",
"Asteroids, comets, and dust particles all go around the sun.",
"Earth is one of eight planets that go around the sun.",
"Asteroids, comets, and dust particles all go around the sun,",
"because gravity, gravity, gravity, gravity, gravity,",
"because",

"(verse 1)",
"Everything is made up of matter.",
"The amount of matter is called mass.",
"Now some objects have great mass than others.",
"Some objects have little.",
"In space objects with greater mass",
"pull other objects together, together.",

"(chorus)",
"Earth is one of eight planets that go around the sun.",
"Asteroids, comets, and dust particles all go around the sun.",
"Earth is one of eight planets that go around the sun.",
"Asteroids, comets, and dust particles all go around the sun,",
"because gravity, gravity, gravity, gravity, gravity,",
"because",

"(verse 2)",
"Without gravity everything on earth",
"will go floating in the air.",
"Gravity pulling us towards earth’s center",
"keeps us here, keeps us here.",
"So, when you jump up, you go back down.",
"Throw a ball up and it comes right down.",
"That’s gravity, gravity, gravity, gravity, gravity,",
"because",

"(chorus)",
"Earth is one of eight planets that go around the sun.",
"Asteroids, comets, and dust particles all go around the sun.",
"Earth is one of eight planets that go around the sun.",
"Asteroids, comets, and dust particles all go around the sun,",
"because gravity, gravity, gravity, gravity, gravity,",
"because…",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Earth's Water",
    slug: "earth’swater",
    standardNumber: "ESS.3.2",
    description: "Understand the structures of the Earth’s surface using models.",
    video: "",
    music: "",
    lyrics: [

],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Landforms",
    slug: "landforms",
    standardNumber: "ESS.3.2",
    description: "Understand the structures of the Earth’s surface using models.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Flandforms2025song.mp3?alt=media&token=73a58a38-9970-412c-9327-17c270bcd5e2",
    lyrics: ["(chorus)",
"What shapes landforms?,",
"Processes from water, ice, wind, and gravity.,",
"What shapes landforms?,",
"Processes from water, ice, wind, and gravity.,",
"What shapes landforms?,",
"Processes from water, ice, wind, and gravity.,",
"What shapes landforms?,",
"Processes from water, ice, wind, and gravity.,",

"(verse)",
"Mountains are very high landforms.,",
"You won’t find other landforms as tall.,",
"A hill is a raised area of land.,",
"A cave is a hole in a hill or a mountain.,",
"Volcanoes have openings at the top,",
"That let out lava—hot, melting rock.,",
"Valleys are low areas between mountains,,",
"Formed by glaciers or rivers over time.,",
"A canyon is a deep valley with steep sides.,",
"Plains are flat lands covered by the sky.,",
"Earth has many beautiful landforms.,",
"Earth has many beautiful landforms.,",

"(chorus)",
"What shapes landforms?,",
"Processes from water, ice, wind, and gravity.,",
"What shapes landforms?,",
"Processes from water, ice, wind, and gravity.,",
"What shapes landforms?,",
"Processes from water, ice, wind, and gravity.,",
"What shapes landforms?,",
"Processes from water, ice, wind, and gravity.,",

"© Smart Board Learning, LLC. All rights reserved.",
],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Sun to Pluto",
    slug: "suntopluto",
    standardNumber: "ESS.3.1",
    description: "Remember the major components and patterns observed in the earth/moon/sun system.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsuntopluto2025video.mp4?alt=media&token=591b45c6-e25e-4893-870b-8403d0f50786",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsuntopluto2025song.mp3?alt=media&token=ad0eed59-ab71-47c3-b765-7fdb1d59a7fc",
    lyrics: ["We will start from the sun, then we’ll travel to the planets,",
"One by one, one by one.",
"(Verse 1)",
"First stop is the Sun, some people call it Sol,",
"It provides energy for the life we know.",
"Next stop is Mercury, very little gravity,",
"First planet from the sun, spins very slowly.",
"Next stop,",
"Second planet from the sun, it’s Venus,",
"Hostile, thick clouds make Venus the meanest.",
"Next stop,",
"Third planet from the sun, yes, Earth,",
"It’s 70 percent water with one moon called Luna.",
"Next stop,",
"Fourth planet from the sun, it’s Mars,",
"Scientists believe it once had lakes and oceans.",
"Next stop is Jupiter, gravity will pull on you,",
"Add a hundred pounds to the weight on Jupiter.",
"(Chorus)",
"We will start from the sun, then we’ll travel to the planets,",
"One by one, one by one.",
"We will start from the sun, then we’ll travel to the planets,",
"One by one, one by one.",
"(Verse 2)",
"Next stop is Saturn, see the ring pattern,",
"Saturn has more moons than any other planet.",
"Next stop is Uranus, a planet very old,",
"22 moons, identical to Neptune.",
"Next stop is Neptune with 13 moons,",
"so far, that’s all we know of.",
"Next stop is Pluto with a new status.",
"Scientists now say Pluto is not a planet.",
"(Chorus)",
"We will start from the sun, then we’ll travel to the planets,",
"One by one, one by one.",
"We will start from the sun, then we’ll travel to the planets,",
"One by one, one by one.",
"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Earth's Rotation",
    slug: "earthsrotation",
    standardNumber: "ESS.3.1",
    description: "Remember the major components and patterns observed in the earth/moon/sun system.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fearthsrotation.mp4?alt=media&token=a31d8de2-9598-4afe-bfcb-c3b51a18246c",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fearthsrotation.mp3?alt=media&token=9312642c-9568-452a-8cc8-634c7e5d125f",
    lyrics: ["(chorus)",
"Earth rotates around and around,",
"around and around again.",
"Earth rotates around and around,",
"around and around again.",

"(verse)",
"The Earth spins on its axis,",
"it's turning, it's turning.",
"Makes the sky look like it's moving,",
"it's turning, it's turning.",
"It makes the sun, moon, and stars ",
"look like they’re rising in the east.",
"Then, cross the sky to set in the west, eventually.",
"That's because the Earth is turning, spinning on its axis.",
"It makes a full turn every 24 hours.",
"That is the reason for our day and night, night and day.",
"That is the reason for our day and night, night and day.",

"(chorus)",
"Earth rotates around and around,",
"around and around again.",
"Earth rotates around and around,",
"around and around again.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Earth's Revolution",
    slug: "earthsrevolution",
    standardNumber: "ESS.3.1",
    description: "Remember the major components and patterns observed in the earth/moon/sun system.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fearthsrevolution.mp4?alt=media&token=49a38c8b-48fc-4c3c-92ca-463a577121dc",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fearthsrevolution2025song.mp3?alt=media&token=29c46e1a-08f3-4b3c-ac70-d64d55ec2386",
    lyrics: ["(verse)",
"A revolution is one year,",
"365 days is how long it takes",
"for the Earth to go around the Sun.",
"It takes one year, that's a revolution.",

"(chorus)",
"Earth's revolution, orbit of the Earth.",
"Earth's revolution, orbit of the Earth.",
"Earth's revolution, orbit of the Earth.",
"Earth's revolution.",

"(verse)",
"A revolution is one year,",
"365 days is how long it takes",
"for the Earth to go around the Sun.",
"It takes one year, that's a revolution.",

"(chorus)",
"Earth's revolution, orbit of the Earth.",
"Earth's revolution, orbit of the Earth.",
"Earth's revolution, orbit of the Earth.",
"Earth's revolution, orbit of the Earth.",
"Earth's revolution, orbit of the Earth.",
"Earth's revolution, orbit of the Earth.",
"Earth's revolution, orbit of the Earth.",
"Earth's revolution.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Constellations",
    slug: "constellations",
    standardNumber: "ESS.3.1",
    description: "ESS.3.1 Remember the major components and patterns observed in the earth/moon/sun system.",
    video: "",
    music: "",
    lyrics: [

],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Moon Phases Rap",
    slug: "moonphasesrap",
    standardNumber: "ESS.3.1",
    description: "Remember the major components and patterns observed in the earth/moon/sun system.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fmoonphasesrap2025video.mp4?alt=media&token=b2c7a588-ca4a-4103-b790-c9e5b040a867",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmoonphasesrap2025song.mp3?alt=media&token=88173bf0-b997-4602-b9b3-671337ff8cc1",
    lyrics: ["(Chorus)",
"Phases of the moon.",
"New moon, waxing crescent, first quarter, waxing gibbous.",
"Phases of the moon.",
"Full moon, waning gibbous, last quarter, waning crescent.",
"Phases of the moon.",
"New moon, waxing crescent, first quarter, waxing gibbous.",
"Phases of the moon.",
"Full moon, waning gibbous, last quarter, waning crescent.",
"(Verse 1)",
"When the moon is in the same direction of the sun,",
"It’s called the new moon, new moon.",
"When you don’t see no light, coming from the moon,",
"It is a dark moon, called the new moon.",
"A crescent moon is in the next stage,",
"When the moon is lit a quarter of the way.",
"Less than half but more than zero.",
"This is called a crescent moon, true.",
"Now a quarter moon’s a half-moon.",
"You see, a half-moon’s a quarter moon,",
"Quarter moon’s a half-moon.",
"They call a half-moon a quarter moon, word,",
"Because it made a quarter of its turn around the earth.",
"You see half of the moon lit up,",
"And I know what you’re thinking but,",
"It’s a half-moon, called a quarter moon.",
"Half-moon’s a quarter moon,",
"Quarter moon’s a half-moon.",
"(Chorus)",
"Phases of the moon.",
"New moon, waxing crescent, first quarter, waxing gibbous.",
"Phases of the moon.",
"Full moon, waning gibbous, last quarter, waning crescent.",
"Phases of the moon.",
"New moon, waxing crescent, first quarter, waxing gibbous.",
"Phases of the moon.",
"Full moon, waning gibbous, last quarter, waning crescent.",
"(Verse 2)",
"Now, the gibbous moon is a little more full,",
"But not all the way full.",
"The lit-up part is between a full moon,",
"And a half-moon called the gibbous moon.",
"Now the full moon shines so bright.",
"You see the full moon light up the night.",
"Halfway through a circle, circle,",
"You’ll see the full moon light up the night.",
"(Chorus)",
"Phases of the moon.",
"New moon, waxing crescent, first quarter, waxing gibbous.",
"Phases of the moon.",
"Full moon, waning gibbous, last quarter, waning crescent.",
"Phases of the moon.",
"New moon, waxing crescent, first quarter, waxing gibbous.",
"Phases of the moon.",
"Full moon, waning gibbous, last quarter, waning crescent.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Moon Phases Rock",
    slug: "moonphasesrock",
    standardNumber: "ESS.3.1",
    description: "Remember the major components and patterns observed in the earth/moon/sun system.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fmoonphasesrock2025video.mp4?alt=media&token=25932096-f065-4705-b4e8-859a6ddc48cb",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmoonphasesrock2025song.mp3?alt=media&token=526ab6eb-b5cd-4118-aedf-8ee73536aa1a",
    lyrics: ["(Chorus)",
"New moon, waxing crescent, first quarter, waxing gibbous.",
"Phases of the moon, phases of the moon.",
"Full moon, waning gibbous, last quarter, waning crescent.",
"Phases of the moon, phases of the moon.",
"(Verse 1)",
"The moon is in the same direction of the sun,",
"It’s a new moon, a new moon, a new moon.",
"When there’s no light coming from the moon,",
"It’s a new moon, a new moon, a new moon.",
"The moon is lit a quarter of the way,",
"It’s a crescent moon, crescent moon, crescent moon.",
"The moon is lit half of the way,",
"It’s a quarter moon, quarter moon, a quarter moon.",
"The moon made a quarter of its turn around the earth,",
"It’s a quarter moon, quarter moon, a quarter moon.",
"(Chorus)",
"New moon, waxing crescent, first quarter, waxing gibbous.",
"Phases of the moon, phases of the moon.",
"Full moon, waning gibbous, last quarter, waning crescent.",
"Phases of the moon, phases of the moon.",
"(Verse 2)",
"The next phase is between a half and a full moon,",
"Gibbous moon, gibbous moon, third quarter almost full.",
"Now the full moon shines so bright.",
"You see the full moon light up the night.",
"Halfway through a circle you’ll see the full moon",
"Light up the night, light up the night.",
"(Chorus)",
"New moon, waxing crescent, first quarter, waxing gibbous.",
"Phases of the moon, phases of the moon.",
"Full moon, waning gibbous, last quarter, waning crescent.",
"Phases of the moon, phases of the moon.",
"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Skeletal system",
    slug: "skeletalsystem",
    standardNumber: "LS.3.1",
    description: "Understand human body systems and how they are essential for life: protection, movement.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fskeletalsystem2025video.mp4?alt=media&token=9e5369d4-a95d-45aa-8668-dd10735197ba",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fskeletalsystem2025song.mp3?alt=media&token=2e53f879-e8b5-488a-921f-b83a0feacd79",
    lyrics: ["(chorus)",
"It provides the shape for my body.",
"My bones, my bones, my bones.",
"It protects the organs in my body.",
"My bones, my bones, my bones.",
"With help from muscles, let me move my body.",
"My bones, my bones, my bones.",
"There’re 206 bones in my body",
"That makes up the skeletal system.",

"(verse)",
"The bone in your head is the skull.",
"Your collarbone is the clavicle.",
"Your breastbone is the sternum.",
"The humerus is where your upper arm is.",
"Rib cage is located in your chest.",
"Spine goes down the middle of your back.",
"The pelvis is in your hip, close to where you sit,",
"Where you sit.",
"Ulnar and radius are on your forearm.",
"The femur is your thighbone.",
"Patella is your kneecap.",
"Where your phalanges at? Fingers and your toes.",
"Tibia and fibula are in your lower legs.",
"These are my bones from my head to my toes.",

"(chorus)",
"It provides the shape for my body.",
"My bones, my bones, my bones.",
"It protects the organs in my body.",
"My bones, my bones, my bones.",
"With help from muscles, let me move my body.",
"My bones, my bones, my bones.",
"There’re 206 bones in my body",
"That makes up the skeletal system.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Muscular System",
    slug: "muscularsystem",
    standardNumber: "LS.3.1",
    description: "Understand human body systems and how they are essential for life: protection, movement.",
    video: "",
    music: "",
    lyrics: [

],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "The Skin",
    slug: "theskin",
    standardNumber: "LS.3.1",
    description: "Understand human body systems and how they are essential for life: protection, movement.",
    video: "",
    music: "",
    lyrics: [

],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Plant Parts",
    slug: "plantparts",
    standardNumber: "LS.3.2",
    description: "LS.3.2 Understand how plant structures aid in survival.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fplantparts2025song.mp3?alt=media&token=64dfa273-9473-4f12-ae5f-d08c8e11a18c",
    lyrics: ["(chorus)",
"Plant Parts",
"Roots, stems, leaves, flowers, fruits, seeds",
"Plant Parts",
"Roots, stems, leaves, flowers, fruits, seeds",

"(verse)",
"Plant Parts",
"The Roots take in the water and nutrients OK",
"The Roots hold the Plant down, so it does not blow away",
"Plant Parts",
"The Stem takes the water and nutrients up to the Leaves",
"The Leaves make food “Photosynthesis” yes their green",
"The Flowers go through Fertilization they make the seeds",
"The Fruit is the part that swells up and it holds the seeds",
"The Seed is a tiny Plant called the Embryo",
"and it's waiting to Germinate so that it can grow",

"(chorus)",
"Plant Parts",
"Roots, stems, leaves, flowers, fruits, seeds",
"Plant Parts",
"Roots, stems, leaves, flowers, fruits, seeds",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Plant Life Cycles",
    slug: "plantlifecycles",
    standardNumber: "LS.3.2",
    description: "LS.3.2 Understand how plant structures aid in survival.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fplantlifecycle.mp4?alt=media&token=04c5304e-ef30-4fec-b739-882b2fd418ab",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fplantlifecycle.mp3?alt=media&token=20abb63d-b1eb-4ab8-b653-4bd0e6bffc81",
    lyrics: ["(chorus)",
"Plant life cycle, oh-wo-wo- oh -wo-wo.,",
"Plant life cycle, oh-wo-wo- oh -wo-wo.,",
"Plant life cycle, oh-wo-wo- oh -wo-wo.,",
"Plant life cycle, oh-wo-wo- oh -wo-wo.,",

"(verse)",
"Now, all plant seeds have an outer cover called a seed coat,",
"to protect the plant inside the seed called the embryo.,",
"When the seed germinates, the root bust out then start growing down.,",
"Then the seed germinates, the shoot bust out, grows up above the ground.,",
"Now it’s a sprout right there.,",
"With help from the water, soil, sun, and air,",
"the plant becomes a seedling.,",
"A small plant with a few leaves.,",
"The next stage is a young adult plant.,",
"Over time it becomes a full adult plant.,",
"Then you’ll see the flowers or spores,",
"used to reproduce and make more,,",
"and make more,,",
"through pollination.,",

"(chorus)",
"Plant life cycle, oh-wo-wo- oh -wo-wo.,",
"Plant life cycle, oh-wo-wo- oh -wo-wo.,",
"Plant life cycle, oh-wo-wo- oh -wo-wo.,",
"Plant life cycle, oh-wo-wo- oh -wo-wo.,",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Photosynthesis",
    slug: "photosynthesis",
    standardNumber: "LS.3.2",
    description: "Understand how plant structures aid in survival.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fphotosynthesis2025video.mp4?alt=media&token=f1dd2985-8798-48a4-bac0-e8e9ad8cd07d",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fphotosynthesis2025song.mp3?alt=media&token=4c2bbcca-ccbe-4515-be6f-8604eb8bb65e",
    lyrics: ["(Chorus)",
"Photosynthesis is the process of how plants make food.",
"Photosynthesis is the process of how plants make food.",
"Photosynthesis is the process of how plants make food.",
"Photosynthesis is the process of how plants make food.",

"(Verse)",
"Energy coming from the sunlight, is what we need to get this started.",
"Water gathered by the roots right, is what we need to get this started.",
"Carbon dioxide from the air, is what we need to get this started.",
"Chlorophyll in the cells of green plants, is what we need to get this started.",
"The chlorophyll takes in the light from the sun.",
"The sun's energy splits the water into hydrogen and oxygen.",
"The hydrogen mixes with the carbon dioxide to make the food, yeah,",
"and the food is carried throughout the plant while the oxygen goes into the air.",

"(Chorus)",
"Photosynthesis is the process of how plants make food.",
"Photosynthesis is the process of how plants make food.",
"Photosynthesis is the process of how plants make food.",
"Photosynthesis is the process of how plants make food.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Plants Need the Right Space",
    slug: "plantsneedtherightspace",
    standardNumber: "LS.3.2",
    description: "Understand how plant structures aid in survival.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fplantsandanimalsneedtheirspace2025video.mp4?alt=media&token=db3fabd6-e651-4243-b8b5-fada18047b02",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fplantsandanimalsneedtheirspace2025song.mp3?alt=media&token=006814cd-57d6-4312-b230-a84afa79a47f",
    lyrics: ["(Chorus)",
"Plants and animals need their space,",
"Water, food, and a safe, good place.",
"Hot or cold, it must feel right,",
"So, they can grow and live their life!",

"(Verse 1)",
"Animals need water, food, and air,",
"Shelter from rocks or trees they share.",
"Plants need sunlight, space to grow,",
"And bees to help their seeds to sow!",

"(Chorus)",
"Plants and animals need their space,",
"Water, food, and a safe, good place.",
"Hot or cold, it must feel right,",
"So, they can grow and live their life!",

"(Verse 2)",
"A small change can mean a lot,",
"Too little water, or too hot.",
"The parts of nature work as one,",
"Helping life get what’s to be done!",

"(Outro)",
"Living and nonliving work together,",
"For plants and animals, now and forever.",
"An ecosystem is a home, it’s true,",
"Taking care of it is up to me and you!",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Soil",
    slug: "soil",
    standardNumber: "LS.3.2",
    description: "Understand how plant structures aid in survival.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsoil2025video.mp4?alt=media&token=3bca78d6-bf7e-41d8-aeac-e798bd67dc16",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsoil2025song.mp3?alt=media&token=228811c5-3593-4ea7-8753-cd5af3e86ffd",
    lyrics: ["(Chorus)",
"Going low, soil. Going low, soil.",
"Going low, soil. Going low, soil.",
"Getting down and dirty.",
"Getting down and dirty.",
"Getting down and dirty.",
"Getting down and dirty.",

"(Verse)",
"Soil is a mixture of organic materials, air, and water,",
"rocks broken down due to weathering,",
"remains of dead plants and animals, everything.",
"Soil covers a lot of Earth’s land.",
"A natural resource that’s important.",
"Soil gives plants the right nutrients,",
"so we can live, so we can live.",

"Microbes in the soil break down and decay,",
"dead organisms every day,",
"and many animals make their homes and shelters,",
"in soil every day.",

"(Chorus)",
"Going low, soil. Going low, soil.",
"Going low, soil. Going low, soil.",
"Getting down and dirty.",
"Getting down and dirty.",
"Getting down and dirty.",
"Getting down and dirty.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Soil Types",
    slug: "soiltypes",
    standardNumber: "LS.3.2",
    description: "Understand how plant structures aid in survival.",
    video: "",
    music: "",
    lyrics: [

],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },
  {
    title: "Soil Is",
    slug: "soilis",
    standardNumber: "LS.3.2",
    description: "Understand how plant structures aid in survival.",
    video: "",
    music: "",
    lyrics: [
],
    gameType: "multipleChoice",
    titleImage: "", // Empty string means no image for Force
  },

];
export default topics;
